import Localbase from 'localbase'

const db = new Localbase('safetipin-db');

export default db;
